// <RichText>: content prose with light markup (§9.7): {chem} · **bold** · _italic_ · blank line = paragraph.
import type { ComponentChildren, JSX } from 'preact';
import { Chem } from './Chem.tsx';

function inline(text: string, keyBase: string): ComponentChildren[] {
  const out: ComponentChildren[] = [];
  const re = /\{([^{}]+)\}|\*\*([^*]+)\*\*|(?<![A-Za-z0-9])_([^_]+)_(?![A-Za-z0-9])|\n/g;
  let last = 0;
  let k = 0;
  for (const m of text.matchAll(re)) {
    if (m.index! > last) out.push(text.slice(last, m.index));
    const key = `${keyBase}-${k++}`;
    if (m[1] !== undefined) out.push(<Chem key={key}>{m[1]}</Chem>);
    else if (m[2] !== undefined) out.push(<strong key={key}>{inline(m[2], key)}</strong>);
    else if (m[3] !== undefined) out.push(<em key={key}>{inline(m[3], key)}</em>);
    else out.push(<br key={key} />);
    last = m.index! + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

/** Inline rich text (no paragraphs). */
export function Rich({ text }: { text: string }): JSX.Element {
  return <>{inline(text, 'r')}</>;
}

/** Block rich text: paragraphs split on blank lines. */
export function RichText({ text, class: cls }: { text: string; class?: string }): JSX.Element {
  const paras = text.split(/\n\s*\n/);
  if (paras.length === 1) return <p class={cls}>{inline(text, 'p0')}</p>;
  return (
    <div class={cls}>
      {paras.map((p, i) => (
        <p key={i}>{inline(p, `p${i}`)}</p>
      ))}
    </div>
  );
}

/** Plain-text version (for aria-live announcements and logs). */
export function richToPlain(text: string): string {
  return text.replace(/\{([^{}]+)\}/g, '$1').replace(/\*\*([^*]+)\*\*/g, '$1').replace(/(?<![A-Za-z0-9])_([^_]+)_(?![A-Za-z0-9])/g, '$1');
}
